///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2021 - 2021
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import { loadHistoryAPI } from "./axios";
import {
  analyticsMockData,
  analyticsInboundOutboundMockData
} from "../__mock__/AnalyticsMockData";

const isMockAnalyticsLoadHistoryEnabled = () => {
  const windowFlag =
    typeof window !== "undefined" && window.REACT_APP_MOCK_ANALYTICS_LOAD_HISTORY;
  if (windowFlag === true || windowFlag === "true") {
    return true;
  }
  return process.env.REACT_APP_MOCK_ANALYTICS_LOAD_HISTORY === "true";
};

export const getLoadHistory = filters => {
  if (isMockAnalyticsLoadHistoryEnabled()) {
    return Promise.resolve({ data: analyticsMockData });
  }
  return loadHistoryAPI.post("api/v1.0/loads/analytics", filters);
};

export const getInboundOutboundRatio = request => {
  if (isMockAnalyticsLoadHistoryEnabled()) {
    return Promise.resolve({ data: analyticsInboundOutboundMockData });
  }
  return loadHistoryAPI.post("api/v1.0/loads/inbound-outbound", request);
};
